import styled from 'styled-components'
import { theme } from 'shared/styles/theme'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	.inputs-group {
		margin: 40px 0;
		width: 100%;

		.input-container + .input-container {
			margin-top: 16px;
		}
	}

	.select-retail {
		display: flex;
		justify-content: flex-end;
		width: 100%;
		margin-bottom: 40px;

		& > div {
			min-width: 50%;
		}
	}

	.submit-button {
		align-self: center;
	}

	.banner-order-list {
		width: 100%;
		background-color: ${theme.colors.white};
		padding: 16px;
		border-radius: 4px;
	}

	.drag-handle {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 12px;

		&:hover {
			cursor: pointer;
			background-color: ${theme.colors.lightGrey};
			border-radius: 4px;
		}

		&:active {
			cursor: grabbing;
		}
	}

	.position-column {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		color: ${theme.colors.blue};
		font-family: 'Montserrat SemiBold', sans-serif;
		margin: 0 auto;
	}

	.image-wrapper {
		width: 67px;
		height: 43px;
		overflow: hidden;
		border-radius: 2px;
	}

	.banner-order-header {
		display: grid;
		grid-template-columns: 30px 90px 2fr 1.5fr 36px;
		column-gap: 12px;
		color: ${theme.colors.blue};
		font-size: 12px;
		font-family: 'Montserrat SemiBold', sans-serif;
		margin-bottom: 12px;
		padding: 0 8px;

		span {
			display: flex;
			align-items: center;
		}

		.register-column-header {
			justify-content: left;
		}
	}

	.banner-order-row {
		display: grid;
		grid-template-columns: 30px 90px 2fr 1.5fr 36px;
		column-gap: 12px;
		align-items: center;
		background-color: ${theme.colors.lightWhite};
		padding: 12px 8px;
		border-radius: 4px;
		font-size: 12px;
		color: ${theme.colors.darkGrey};
	}

	.banner-order-row + .banner-order-row {
		margin-top: 8px;
	}

	.title-column {
		font-size: 12px;
		color: ${theme.colors.darkGrey};
	}

	.banner-image {
		width: 100%;
		height: 100%;
	}

	.link-wrapper {
		max-width: 200px;
		overflow: hidden;
	}

	.register-column {
		text-align: left;
		color: ${theme.colors.darkGrey};
		border-radius: 100px;
		font-size: 12px;
	}

	.switch-status {
		justify-content: flex-start;
	}
`
